<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure">
<figure class="figure">
<p class="fig"><a class="page" id="pii"></a><img alt="" height="600" src="images/WEILER_Fig.01.jpeg" width="459"/></p>
<p class="figcap"><span class="fighn">Figure 1.</span> Maria Baldwin. Cambridge Historical Commission, Cambridge Public Library Collection.</p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Weiler0003.vue?8d02917e